import { render, staticRenderFns } from "./ChartUsersAgeBar.vue?vue&type=template&id=c3f34b90&"
import script from "./ChartUsersAgeBar.vue?vue&type=script&lang=js&"
export * from "./ChartUsersAgeBar.vue?vue&type=script&lang=js&"
import style0 from "./ChartUsersAgeBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports